var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoutIconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.932,
    height: 14.298,
    viewBox: "0 0 16.932 14.298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-logout-1350695",
    transform: "translate(-17.5 -22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8496",
    "data-name": "Group 8496",
    transform: "translate(17.75 22.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8495",
    "data-name": "Group 8495",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9642",
    "data-name": "Path 9642",
    d: "M11.777,11.777a.878.878,0,0,1-1.242-1.242,5.143,5.143,0,1,0-7.273,0,.878.878,0,1,1-1.242,1.242,6.9,6.9,0,1,1,9.756,0ZM7.412,4.552,9.927,7.12A.752.752,0,0,1,8.865,8.184L8,7.317c-.2-.2-.355-.132-.355.145v8.218a.75.75,0,1,1-1.5,0V7.463c0-.278-.159-.343-.355-.145l-.861.867A.752.752,0,0,1,3.871,7.12L6.36,4.555A.73.73,0,0,1,7.412,4.552Z",
    transform: "translate(16.432) rotate(90)",
    fill: "#a3e3d9",
    stroke: "#05a17c",
    strokeWidth: 0.5,
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconLight);
export default __webpack_public_path__ + "static/media/logout-icon-light.041f3cde70a4049a49755f9df5a18f2b.svg";
export { ForwardRef as ReactComponent };